import PropTypes from 'prop-types'
import React from 'react'

import styles from './SliderButton.css'

class SliderButton extends React.Component {
  constructor () {
    super()

    this.handleTouchStart = this.handleTouchStart.bind(this)
    this.handleTouchMove = this.handleTouchMove.bind(this)

    this.handleMouseDown = this.handleMouseDown.bind(this)
    this.handleMouseMove = this.handleMouseMove.bind(this)

    this.handleCancel = this.handleCancel.bind(this)
  }

  componentWillUnmount () {
    // clean up global event listeners
    this.handleCancel()
  }

  render () {
    const { style } = this.props

    return (
      <div
        ref={(node) => { this.element = node }}
        role="button"
        tabIndex={-1}
        className={styles.sliderButton}
        style={style}
        onMouseDown={this.handleMouseDown}
        onTouchStart={this.handleTouchStart}
      >
        <div className={styles.arrowLeft} />
        <div className={styles.arrowRight} />
      </div>
    )
  }

  handleTouchStart (event) {
    // prevent unwanted click events on slider bar
    event.preventDefault()

    document.addEventListener('touchmove', this.handleTouchMove)
    document.addEventListener('touchend', this.handleCancel)
    document.addEventListener('touchcancel', this.handleCancel)
  }

  handleMouseDown () {
    document.addEventListener('mousemove', this.handleMouseMove)
    document.addEventListener('mouseup', this.handleCancel)
  }

  handleTouchMove (event) {
    this.props.onMove(event.touches[0].clientX)
  }

  handleMouseMove (event) {
    this.props.onMove(event.clientX)
  }

  handleCancel () {
    document.removeEventListener('touchmove', this.handleTouchMove)
    document.removeEventListener('touchend', this.handleCancel)
    document.removeEventListener('touchcancel', this.handleCancel)
    document.removeEventListener('mousemove', this.handleMouseMove)
    document.removeEventListener('mouseup', this.handleCancel)
  }
}

SliderButton.defaultProps = {
  style: {}
}

SliderButton.propTypes = {
  style: PropTypes.object,
  onMove: PropTypes.func.isRequired
}

export default SliderButton
